module.exports = __webpack_public_path__ + "static/media/star-half.4ee3bd4c.svg";